import type { ReactNode } from "react";

type AuthPageProps = {
	title: string;
	description?: string;
	children: ReactNode;
	/** Wider column for dense forms (e.g. register two-column grid) */
	variant?: "narrow" | "comfortable";
};

export function AuthPage({
	title,
	description,
	children,
	variant = "narrow",
}: AuthPageProps) {
	const maxWidth = variant === "comfortable" ? "max-w-md" : "max-w-sm";

	return (
		<div className="flex flex-1 flex-col justify-center px-4 py-10 sm:px-6 sm:py-16">
			<div className={`mx-auto w-full ${maxWidth}`}>
				<h1 className="text-center text-2xl font-semibold tracking-tight text-balance text-foreground">
					{title}
				</h1>
				{description ? (
					<p className="mx-auto mt-2 max-w-[40ch] text-center text-base text-pretty text-muted-foreground">
						{description}
					</p>
				) : null}
				<div className="mt-8">{children}</div>
			</div>
		</div>
	);
}
